export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-regular-oblique-web-c5646a47e81eb96f9fa72c58e112b5ed.woff";